import { Text } from '@rsos/base-components';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';

const ToastMessage = ({
  selectedCallerID,
  alertLabel,
}: {
  selectedCallerID: null | string;
  /** Set for alert shares — alerts have no phone number to format. */
  alertLabel?: string | null;
}) => {
  const subject =
    alertLabel ??
    (selectedCallerID
      ? formatInternationalPhoneNumberHuman(selectedCallerID)
      : null);

  if (!subject) return null;

  return (
    <Text>
      Event details from{' '}
      <Text fontWeight="bold" inline>
        {subject}
      </Text>{' '}
      were shared to field responders.
    </Text>
  );
};

export default ToastMessage;
